import React from 'react';
import Layout from 'components/Layout';
import { Box, Grid, Container, Typography } from '@material-ui/core';

import { AccountInfo } from 'components/Account';
import useStyles from './Account.styled';
import i18n from 'i18n-js';

const AccountPage = () => {
  const classes = useStyles();

  return (
    <Layout title={i18n.t('account.title')}>
      <Container className={classes.container}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              <Box fontWeight="fontWeightBold" data-cy="title" fontSize={24} mt={2} mb={3}>
                {i18n.t('account.title')}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <AccountInfo />
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default AccountPage;
